import { inject, Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { catchError, EMPTY, switchMap, tap } from 'rxjs';
import { MediaItem } from '../models';
import { HttpService } from '../services/http.service';
import { PaginationParams } from '../types';

export interface SelectMediaState {
    loading: boolean;
    items: MediaItem[];
    total: number;
}

const initialState: SelectMediaState = {
    loading: false,
    items: [],
    total: 0,
};

@Injectable()
export class SelectMediaStore extends ComponentStore<SelectMediaState> {
    private readonly httpService = inject(HttpService);

    readonly items = this.selectSignal((state) => state.items);
    readonly total = this.selectSignal((state) => state.total);
    readonly loading = this.selectSignal((state) => state.loading);

    constructor() {
        super(initialState);
    }

    readonly getMedia = this.effect<PaginationParams>((params$) =>
        params$.pipe(
            switchMap((params) => {
                this.patchState({ loading: true });
                return this.httpService.getMedia(params).pipe(
                    tap((result) => this.patchState({ loading: false, items: result.payload, total: result.total })),
                    catchError(() => {
                        this.patchState({ loading: false });
                        return EMPTY;
                    }),
                );
            }),
        ),
    );
}
